(function(){
  var root=document.getElementById('nmk'); if(!root) return;
  var cfg={}; try{ cfg=JSON.parse(document.getElementById('nmk-config').textContent); }catch(e){}
  var KEY='nomika.position', KEYE='nomika.email', KEYB='nomika.poured_by';
  /* Link tracking, 14 Oct 2026. A visitor who arrives on a tagged link
     (?utm_source=instagram&utm_medium=bio&utm_campaign=...) keeps that tag in this
     browser, and it travels with the signup so the record says where they came from.
     The signup service already stores it as the utm field; the form never sent it. */
  var KEYU='nomika.utm';
  (function(){
    try{
      var q=new URLSearchParams(location.search);
      var u=['utm_source','utm_medium','utm_campaign'].map(function(k){ return (q.get(k)||'').trim().toLowerCase(); });
      if(u[0]) localStorage.setItem(KEYU, u.join('/').replace(/\/+$/,''));
    }catch(e){}
  })();
  function savedUtm(){ try{ return localStorage.getItem(KEYU)||null; }catch(e){ return null; } }
  /* The light pages, 10 Oct 2026. snippets/nomika-lite.liquid adds .lite before first
     paint when the visitor clicked in from another NOMIKA page or is already on the
     list. A light page never plays the full flash; a neighborhood page plays the short
     two-line one instead (cfg.liteFlash), or none if that line is empty. */
  var LITE=root.classList.contains('lite');

  /* ---- opening sequence, ported from OpeningSequence.jsx ----
     OPENER was 1550 in Base44. Emiko asked for the first line to hold a beat
     longer, 1 Oct 2026, so it is 1900. */
  var OPENER=1900, SECOND=1000, FLASH=600, LAST=850, LINE_ONE=1400, BOTH=2000;
  /* A page may set its own pace for every flash line after the first, through
     flashMs in its config. The homepage does, 10 Oct 2026, because its flash became
     full recollections that 600ms could not carry. Emiko's call. Pages that do not
     pass it, the nine neighborhoods, keep the timings above. */
  var PACE=parseInt(cfg.flashMs,10); if(PACE>0){ SECOND=PACE; FLASH=PACE; LAST=PACE; }
  var TWO_WITH_POUR=1400, POUR_HOLD=1900;
  /* The short flash: line one alone, line two fades in under it, both hold, page opens. */
  var DUO_ONE=900, DUO_BOTH=2200;
  var items=(cfg.flash||[]).map(function(s){return (s||'').trim();}).filter(Boolean);

  var seq=document.getElementById('nmk-seq');
  var opener=document.getElementById('nmk-opener');
  var item=document.getElementById('nmk-item');
  var lines=document.getElementById('nmk-lines');
  var l2=document.getElementById('nmk-l2');

  /* The pour line. Ported from OpeningSequence.jsx: a line that only exists on a pour
     link. Built here rather than in the section markup because the sequence is this
     file's job, and because .hide is visibility, not display, so the space is reserved
     from the first frame and line one never moves. 2 Oct 2026. */
  var l3=null;
  (function(){
    var by=new URLSearchParams(location.search).get('p');
    var n=parseInt(String(by||'').replace(/\D/g,''),10);
    if(!lines || !n || n<1) return;
    l3=document.createElement('p');
    l3.className='three hide';
    l3.id='nmk-l3';
    l3.textContent='No. '+String(n).padStart(4,'0')+' POURED FOR YOU.';
    lines.appendChild(l3);
  })();

  var beats=items.map(function(t,i,all){
    return {kind:'flash',text:t,hold:i===0?OPENER:(i===1?SECOND:(i===all.length-1?LAST:FLASH))};
  });
  beats.push({kind:'line1',hold:LINE_ONE});
  /* Beat two lands the brand's own sentence. When there is a pour line it gets a beat
     of its own after that, rather than arriving on top of the landing, because it is
     addressed to one person and the sentence is not. The two-line hold is shortened to
     pay for it, so a pour link costs about a second more than an ordinary one, not
     three. Emiko's call, 2 Oct 2026, a departure from Base44, which showed both at once. */
  beats.push({kind:'line2',hold: l3 ? TWO_WITH_POUR : BOTH});
  if(l3) beats.push({kind:'line3',hold:POUR_HOLD});

  var timer=null, i=0;
  function finish(){ if(timer) clearTimeout(timer); root.dataset.seq='done'; }
  function render(){
    if(i>=beats.length){ finish(); return; }
    var b=beats[i];
    var isFlash=b.kind==='flash';
    seq.dataset.kind=isFlash?'flash':'line';
    opener.hidden=!(isFlash&&i===0);
    item.hidden=!(isFlash&&i!==0);
    lines.hidden=isFlash;
    if(isFlash){ if(i===0){opener.textContent=b.text;} else {item.textContent=b.text;} }
    else {
      var two = (b.kind==='line2' || b.kind==='line3');
      l2.className = two ? 'two' : 'two hide';
      if(l3) l3.className = (b.kind==='line3') ? 'three' : 'three hide';
    }
    timer=setTimeout(function(){ i++; render(); }, b.hold);
  }
  function duo(a,b){
    root.dataset.seq='running';
    seq.dataset.kind='flash';
    seq.classList.add('duo');
    lines.hidden=true;
    opener.hidden=false; opener.textContent=a;
    item.hidden=false; item.textContent=b; item.style.opacity='0';
    timer=setTimeout(function(){ item.style.opacity='1'; timer=setTimeout(finish, DUO_BOTH); }, DUO_ONE);
  }
  if(seq){
    seq.addEventListener('click', finish);
    var reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if(LITE){
      var lf=(cfg.liteFlash||[]).map(function(s){return (s||'').trim();});
      if(!reduced && lf.length===2 && lf[0] && lf[1]){ duo(lf[0],lf[1]); } else { finish(); }
    }
    else if(reduced || !beats.length){ finish(); }
    else { root.dataset.seq='running'; render(); }
  }

  /* ---- the pour count, read live from the service ---- */
  function liveCount(pos){
    if(!pos) return;
    fetch('/apps/nomika/count?p='+encodeURIComponent(pos),{cache:'no-store'})
      .then(function(r){ return r.json(); })
      .then(function(d){
        var n=(d&&d.pours)||0;
        var a=document.getElementById('nmk-tag-count'); if(a) a.textContent=n;
        var b=document.getElementById('nmk-pour-count'); if(b) b.textContent=n;
      }).catch(function(){});
  }

  /* ---- signup state ---- */
  function pad(n){ return String(n==null?'':n).padStart(4,'0'); }
  var hero=document.getElementById('nmk-hero');
  /* The hero is optional. The wall has no hero, the way Base44's Wall.jsx has none,
     and the first version of this bailed out the moment it could not find the hero's
     number, so a signed-in visitor on the wall got no POUR ONE and no NOT YOU? in the
     footer. The footer belongs to every page. Do not put the early return back. */
  function showTag(num){
    var el=document.getElementById('nmk-num');
    if(el){
      el.textContent=pad(num);
      var ret=document.getElementById('nmk-ret'); if(ret) ret.hidden=false;
      var door=document.getElementById('nmk-door'); if(door) door.hidden=true;
      if(hero) hero.classList.remove('hold');
    }
    ['nmk-fpour','nmk-notyou'].forEach(function(id){ var e=document.getElementById(id); if(e) e.hidden=false; });
    paintTicket(num);
    liveCount(num);
  }

  /* ---- the ticket in the light pages' top bar, 10 Oct 2026 ----
     On the list: shows the number and opens the tag. Not on the list: "Get your number".
     On a page with a hero it switches that page back to the full version, so the signup
     still sends this page's neighborhood. The wall and The story have no hero, so they go home. */
  var lb=null;
  function paintTicket(num){ if(lb && num) lb.textContent='No. '+pad(num); }
  lb=document.getElementById('nmk-lb-ticket');

  var saved=null; try{ saved=localStorage.getItem(KEY); }catch(e){}
  if(saved) showTag(saved);

  if(lb){
    lb.addEventListener('click', function(){
      var p=null; try{ p=localStorage.getItem(KEY); }catch(e){}
      if(p){ openTag(); return; }
      if(hero){
        root.classList.remove('lite');
        window.scrollTo(0,0);
        var em=document.getElementById('nmk-email'); if(em){ try{ em.focus({preventScroll:true}); }catch(e){ em.focus(); } }
      } else { location.href='/'; }
    });
  }

  /* ---- the footer wordmark goes home, 10 Oct 2026, Emiko ----
     Every page's footer carries a signoff wordmark that linked nowhere. Wrapped here
     rather than in four section files so it lives in one place. */
  (function(){
    var so=root.querySelector('footer .signoff'); if(!so || so.querySelector('a')) return;
    var im=so.querySelector('img'); if(!im) return;
    var a=document.createElement('a'); a.href='/'; a.setAttribute('aria-label','NOMIKA home'); a.style.display='block';
    im.parentNode.insertBefore(a,im); a.appendChild(im);
  })();

  /* ---- the story chip, 10 Oct 2026, Emiko ----
     Added to every footer here, beside Instagram, so it lives in one place. Built as
     "About"; renamed "The story" on 11 Oct at her choice, page moved to /pages/story. */
  (function(){
    var ways=root.querySelector('footer .ways'); if(!ways || ways.querySelector('.chip-about')) return;
    var a=document.createElement('a'); a.className='chip chip-about'; a.href='/pages/story'; a.textContent='The story';
    var ig=ways.querySelector('a.chip[target="_blank"]');
    if(ig && ig.parentNode===ways){ var row=document.createElement('div'); row.className='row'; ways.insertBefore(row,ig); row.appendChild(a); row.appendChild(ig); }
    else { ways.appendChild(a); }
  })();

  var form=document.getElementById('nmk-form'), err=document.getElementById('nmk-err'), btn=document.getElementById('nmk-submit');
  function fail(m){ err.textContent=m; err.classList.add('on'); }

  /* A real email has something before the @, something after it, and a dot in the
     domain. Base44 checked for an @ and nothing else, which let a half typed address
     through to Shopify, come back as a 500 HTML page, and tell the person the site
     was broken when all they had done was mistype. Found 2 Oct 2026 by testing. */
  function looksLikeEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  if(form) form.addEventListener('submit', function(e){
    e.preventDefault(); err.classList.remove('on');
    var email=document.getElementById('nmk-email').value.trim();
    if(!looksLikeEmail(email)){ fail('Enter a valid email.'); return; }
    btn.disabled=true; var old=btn.textContent; btn.textContent='Sending';
    var qs=new URLSearchParams(location.search);
    fetch('/apps/nomika/signup',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:email,neighborhood:cfg.neighborhood||'direct',poured_by:qs.get('p')||null,utm:savedUtm()})})
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(d){ if(!d||!d.position) throw 0;
        try{ localStorage.setItem(KEY,d.position); localStorage.setItem(KEYE,email);
          var by=qs.get('p'); if(by) localStorage.setItem(KEYB,by); }catch(e){}
        showTag(d.position);
        /* Base44's HeroLockup renders Confirmation straight off the signup result, so
           the tag is on screen the instant somebody joins. */
        openTag();
      })
      .catch(function(){ btn.disabled=false; btn.textContent=old; fail('Something went wrong. Try again.'); });
  });

  var ny=document.getElementById('nmk-notyou-btn');
  if(ny) ny.addEventListener('click', function(){
    try{ localStorage.removeItem(KEY); localStorage.removeItem(KEYE); localStorage.removeItem(KEYB); }catch(e){}
    location.reload();
  });

  /* ---- pour ---- */
  function revealRaw(){ var r=document.getElementById('nmk-tag-link'); if(r) r.classList.add('on'); }
  function legacy(url,el){
    var ta=document.createElement('textarea'); ta.value=url; ta.setAttribute('readonly','');
    ta.style.position='absolute'; ta.style.left='-9999px'; document.body.appendChild(ta); ta.select();
    try{ document.execCommand('copy'); el.textContent='COPIED'; }catch(e){ el.textContent=url; revealRaw(); }
    document.body.removeChild(ta);
  }
  /* The pour link carries the room it was poured from. Base44's Pour.jsx looked the
     pourer up and rendered the neighborhood they had signed up in; the page already
     knows which neighborhood it is, so the link is simply built from it and nobody
     has to be looked up, redirected or waited for. Poured from the homepage, the
     rooms page or the wall, it still points at the front door. 2 Oct 2026. */
  var HOODS='chinatown,lower-east-side,nolita,soho,east-village,chelsea,meatpacking,times-square,williamsburg'.split(',');
  function pourPath(){
    var h=cfg.neighborhood;
    return (h && HOODS.indexOf(h)!==-1) ? ('/pages/'+h) : '/';
  }
  function share(el){
    var pos=null; try{ pos=localStorage.getItem(KEY); }catch(e){}
    var url=location.origin+pourPath()+(pos?('?p='+pos):'');
    if(navigator.share){ navigator.share({title:'NOMIKA',text:'No. '+pad(pos)+' poured you one.',url:url}).catch(function(){}); return; }
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(function(){ el.textContent='COPIED'; },function(){ legacy(url,el); }); return; }
    legacy(url,el);
  }
  var pour=document.getElementById('nmk-pour');
  if(pour) pour.addEventListener('click', function(){ share(pour); });

  /* ---- the coat check tag, ported from Confirmation.jsx ---- */
  var tag=document.getElementById('nmk-tag');
  function openTag(){
    var pos=null; try{ pos=localStorage.getItem(KEY); }catch(e){}
    if(!pos||!tag) return;
    var el=document.getElementById('nmk-tag-num'); if(el) el.textContent=pad(pos);
    var by=null; try{ by=localStorage.getItem(KEYB); }catch(e){}
    var byWrap=document.getElementById('nmk-tag-by');
    if(byWrap){
      if(by){ document.getElementById('nmk-tag-byno').textContent=pad(by); byWrap.hidden=false; }
      else { byWrap.hidden=true; }
    }
    var raw=document.getElementById('nmk-tag-link');
    if(raw){ raw.textContent=location.origin+pourPath()+'?p='+pos; raw.classList.remove('on'); }
    liveCount(pos);
    tag.classList.add('on');
    document.body.style.overflow='hidden';
  }
  function closeTag(){ if(!tag) return; tag.classList.remove('on'); document.body.style.overflow=''; }
  var numBtn=document.querySelector('#nmk .numbtn');
  if(numBtn) numBtn.addEventListener('click', openTag);
  var xBtn=document.getElementById('nmk-tag-close');
  if(xBtn) xBtn.addEventListener('click', closeTag);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeTag(); });
  var tagPour=document.getElementById('nmk-tag-pour');
  if(tagPour) tagPour.addEventListener('click', function(){ share(tagPour); });

  /* ---- toast line: 1100ms a beat, SAY YOURS. holds 4000ms ---- */
  var tl=document.getElementById('nmk-toast');
  if(tl){
    var sp=tl.querySelectorAll('span'), last=sp.length-1, k=0;
    if(sp.length){
      if(window.matchMedia('(prefers-reduced-motion:reduce)').matches){ k=last; }
      var paint=function(){ for(var j=0;j<sp.length;j++){ sp[j].className = (j===k)?'':'hide'; } };
      paint();
      if(!window.matchMedia('(prefers-reduced-motion:reduce)').matches){
        (function tick(){ setTimeout(function(){ k=(k+1)%sp.length; paint(); tick(); }, k===last?4000:1100); })();
      }
    }
  }
})();